<template>
  <main class="bg-gray-100 min-h-screen">
    <header class="max-w-4xl">
      <div
        class="border-b border-gray-100 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8"
      >
        <div class="flex-1 min-w-0">
          <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
            {{ $t('invoice_patient_title', this.invoice) }}
          </h1>
        </div>
      </div>
      <sqr-progress v-show="loading" />
      <sqr-error-banner :error="loadError" @retry="reload()" />
    </header>

    <section class="max-w-4xl" v-if="invoice && !loading && !loadError">
      <div class="py-8 max-w-4xl lg:px-8">
        <patient-form
          class="field"
          :patient="invoice.patient"
          @change="proxyFieldSet"
          :validations="$v.invoice.patient"
        />
        <div
          class="sticky bottom-0 border-t border-gray-300 bg-gray-100 mt-8 p-4 lg:-mx-1"
        >
          <sqr-error-text :error="saveError" />
          <div class="flex justify-end space-x-2">
            <sqr-button
              :label="$t('buttons_back')"
              color="transparent"
              @click="$router.back()"
            />
            <sqr-button
              :label="$t('buttons_change')"
              @click="saveAndGo()"
              color="blue"
            />
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import { validationMixin } from 'vuelidate';

import SqrButton from '@/components/SqrButton';
import PatientForm from '@/forms/PatientForm';
import patientVal from '@/validations/patient';
import patient from '@/filters/patient';

export default {
  name: 'InvoicePatient',
  mixins: [validationMixin],
  components: { PatientForm, SqrButton },
  computed: {
    ...mapGetters('account', ['accountId']),
    ...mapGetters('invoice', ['invoice', 'loading', 'loadError']),
    ...mapGetters('invoice', {
      invoiceSaving: 'saving',
      invoiceSaveError: 'saveError'
    }),
    ...mapGetters('patient', { patient: 'record' }),
    ...mapGetters('patient', {
      patientSaving: 'saving',
      patientSaveError: 'saveError'
    })
  },
  validations: {
    invoice: {
      patient: patientVal
    }
  },
  mounted() {
    this.$a().logEvent('invoice_patient');
    this.reload();
  },
  methods: {
    ...mapMutations('invoice', { invoiceFieldSet: 'fieldSet' }),
    ...mapActions('invoice', {
      invoiceSubscribe: 'subscribe',
      invoiceSave: 'save'
    }),

    ...mapMutations('patient', { patientFieldSet: 'fieldSet' }),
    ...mapActions('patient', {
      patientInit: 'init',
      patientSubscribe: 'subscribe',
      patientSave: 'save'
    }),

    proxyFieldSet(payload) {
      this.invoiceFieldSet({ group: 'patient', ...payload });
    },

    async reload() {
      const accountId = this.accountId;
      const id = this.$route.params.id;
      const invoice = await this.invoiceSubscribe({ accountId, id });

      if (invoice && invoice.patientId && invoice.patientId !== 'embeded') {
        await this.patientSubscribe({ id: invoice.patientId });
      }

      if (this.$route.query.validation === 'true') this.$v.$touch();
    },

    sync() {
      const patient = JSON.parse(JSON.stringify(this.patient));
      this.invoiceFieldSet({ field: 'patient', value: patient });
    },

    async saveAndGo() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.proxyFieldSet({
        field: 'name',
        value: patient(this.invoice.patient)
      });
      await this.invoiceSave({ accountId: this.accountId });
      this.$router.back();
    }
  }
};
</script>
